import React from 'react';
import { observer } from 'mobx-react';
import { BooleanStore } from 'ui/base/input/store';
import { InputChangeEvent, InputProps } from 'ui/base/types';


export type CheckboxInputProps = Omit<InputProps, 'type' | 'value' | 'onChange'> & {
  store: BooleanStore;
  onChange?: (value: boolean) => Promise<boolean> | boolean | void;
};

export const CheckboxInput = observer(({ store, onChange, ...props }: CheckboxInputProps) => {
  const actualOnChange = React.useCallback((event: InputChangeEvent) => {
    const original = store.value;
    store.setValue(event.target.checked);
    if (onChange != null) {
      const result = onChange(event.target.checked);
      if (result instanceof Promise) {
        result.then(success => {
          if (success === false) {
            store.setValue(original);
          }
        });
      } else if (result === false) {
        store.setValue(original);
      }
    }
  }, [store, onChange]);

  return <input type='checkbox' checked={store.value} onChange={actualOnChange} {...props}/>;
});
